module.exports = {"ru":{"showAllRowsButton":"Показать еще","hideAllRowsButton":"Скрыть"},"en":{"showAllRowsButton":"Show more","hideAllRowsButton":"Hide"}}


//////////////////
// WEBPACK FOOTER
// ./temp/components/tables/.variant/base/text.yaml
// module id = 233
// module chunks = 0